import styled from "styled-components";
import { CSSObjectWithLabel } from "react-select";

import {
  COLORS,
  FONT_WEIGHT,
  FONT_SIZE,
  formLabelStyles,
} from "../../../constants/Styles";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${formLabelStyles};
`;

const getContainerStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    width: "100%",
  };
};

const getControlStyles = () => {
  return {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    borderStyle: "solid",
    minHeight: "2.375rem",
    padding: "0 1rem",
    borderColor: "transparent",
    borderWidth: "1px",
    borderRadius: "0.5rem",
    fontWeight: `${FONT_WEIGHT.weight400}`,
    fontSize: `${FONT_SIZE.size16}`,
    backgroundColor: `${COLORS.inputGray}`,
    color: COLORS.black,
  };
};

const getOptionStyles = (
  provided: CSSObjectWithLabel,
  isSelected: boolean,
  isDisabled: boolean,
) => {
  return {
    ...provided,
    backgroundColor: isSelected ? COLORS.accent : COLORS.inputGray,
    color: isDisabled
      ? COLORS.disabled
      : isSelected
        ? COLORS.altSecondary
        : COLORS.secondaryLight,
    padding: "0.25rem",
    fontWeight: `${FONT_WEIGHT.weight400}`,
    cursor: isDisabled ? "not-allowed" : "pointer",
    ...(isDisabled && { filter: "brightness(50%)" }),
  };
};

const getGenericStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    padding: "0",
    margin: "0",
  };
};

const getInputStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    padding: "0",
    margin: "0",
    color: COLORS.secondary,
  };
};

const getMultiValueStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    backgroundColor: COLORS.secondaryLight,
  };
};

const getMultiValueRemoveStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    backgroundColor: COLORS.secondaryLight,
    "&:hover": {
      backgroundColor: COLORS.secondaryLight,
      color: COLORS.black,
      filter: "brightness(150%)",
    },
  };
};

const getMenuStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    padding: "0",
    margin: "0",
    backgroundColor: `${COLORS.inputGray}`,
  };
};

const getMenuListStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    "::-webkit-scrollbar": {
      width: ".25rem",
      backgroundColor: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: `${COLORS.secondaryLight}`,
      borderRadius: ".25rem",
    },
    "::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
  };
};

const getIndicatorSeparatorStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    display: "none",
  };
};

const getIndicatorStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    padding: "0",
    color: COLORS.secondaryLight,
    margin: "0",
    cursor: "pointer",
    "&:hover": { filter: "brightness(150%)" },
  };
};

const getLoadingIndicatorStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    color: COLORS.secondaryLight,
  };
};

const getGroupHeadingStyles = (provided: CSSObjectWithLabel) => {
  return {
    ...provided,
    textTransform: "none",
    padding: "0.25rem",
  };
};

export {
  Container,
  getControlStyles,
  getContainerStyles,
  getOptionStyles,
  getGenericStyles,
  getInputStyles,
  getMultiValueStyles,
  getMultiValueRemoveStyles,
  getMenuStyles,
  getIndicatorSeparatorStyles,
  getIndicatorStyles,
  getLoadingIndicatorStyles,
  getGroupHeadingStyles,
  getMenuListStyles,
};
